import { FC } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { EventBundleDto, priceFormatter } from '@sweatpals/shared';
import { CoreButtonBase, useStyles } from '@sweatpals/react-ui-kit';
import { eventBundleCardStyles } from './event-bundle-card.styles';

export interface EventBundleCardProps {
	hostPrimaryColorHex?: string;
	eventBundle: EventBundleDto;
	sx?: SxProps<Theme>;
	onGetEventBundle?(bundleId: string): void;
}

export const EventBundleCard: FC<EventBundleCardProps> = (props) => {
	const { hostPrimaryColorHex, sx, eventBundle, onGetEventBundle } = props;

	const handleClickGet = () => {
		onGetEventBundle?.(eventBundle.id);
	};

	const styles = useStyles(eventBundleCardStyles, hostPrimaryColorHex, sx);

	return (
		<Box sx={styles.root}>
			<Box sx={styles.content}>
				<Box sx={styles.header}>
					<Typography sx={styles.headerTitle}>event bundle: {eventBundle.name}</Typography>
				</Box>
				<Box sx={styles.titleWrapper}>
					<Typography sx={styles.title}>{priceFormatter(eventBundle.price)} /</Typography>
					<Typography sx={styles.titleEvents}>{eventBundle.visitsAmount} events</Typography>
				</Box>

				<Typography sx={styles.description}>{eventBundle.description}</Typography>

				<CoreButtonBase sx={styles.typeGetButton} onClick={handleClickGet}>
					Purchase
				</CoreButtonBase>
			</Box>
		</Box>
	);
};
